import type { Guest, GuestStatus } from '@common/types';

const FIRST_NAMES = [
  'Aiden',
  'Sara',
  'Marcus',
  'Olivia',
  'Nathan',
  'Priya',
  'Lukas',
  'Maya',
  'Hiroshi',
  'Eleanor',
  'Diego',
  'Ines',
  'Kwame',
  'Anouk',
  'Theo',
  'Yara',
  'Lena',
  'Idris',
  'Soo-jin',
  'Mateus',
  'Zara',
  'Felix',
  'Amara',
  'Jonas',
  'Noor',
  'Bastien',
  'Camille',
  'Rohan',
  'Ines',
  'Adriana',
  'Hugo',
  'Lila',
  'Tomasz',
  'Greta',
  'Pablo',
  'Hana',
  'Caleb',
  'Iris',
  'Otis',
  'Wren',
  'Sven',
  'Mira',
  'Quinn',
  'Sasha',
  'Vance',
  'Esme',
  'Reza',
  'Naomi',
  'Bruno',
  'Talia',
];

const LAST_NAMES = [
  'Hemmings',
  'Patel',
  'Whitfield',
  'Bergstrom',
  'Okafor',
  'Sato',
  'Lindberg',
  'Costa',
  'Singh',
  'Romano',
  'Vargas',
  'Mensah',
  'Oduya',
  'Schneider',
  'Marchetti',
  'Andersson',
  'Khoury',
  'Chen',
  'Park',
  'da Silva',
  'Reinhardt',
  'Holm',
  'Nazari',
  'Beaumont',
  'Stojanovic',
  'Nakamura',
  'Ferreira',
  'Lutz',
  'Ito',
  'Mbeki',
  'Carrasco',
  'Voss',
  'Tremblay',
  'Bjornsson',
  'Dvorak',
  'Aslan',
  'Ricci',
  'Halvorsen',
  'Iglesias',
  'O Connor',
  'Petrov',
  'Larsen',
  'Adeyemi',
  'Saito',
  'Wallace',
  'Lefevre',
  'Hassan',
  'Engman',
  'Forsberg',
  'Beauchamp',
];

const STATUSES: GuestStatus[] = ['in-house', 'arriving', 'departed'];

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

function formatDate(d: Date): string {
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
}

function pick<T>(arr: T[], i: number): T {
  return arr[i % arr.length];
}

function buildSeedGuests(count: number): Guest[] {
  const today = new Date('2026-05-07T00:00:00Z');
  const guests: Guest[] = [];
  for (let i = 0; i < count; i++) {
    const first = pick(FIRST_NAMES, i);
    const last = pick(LAST_NAMES, (i * 7) % LAST_NAMES.length);
    const status = STATUSES[i % STATUSES.length];
    const arrivalOffset =
      status === 'arriving' ? 1 + (i % 6) : status === 'in-house' ? -1 - (i % 4) : -7 - (i % 10);
    const stayLength = 2 + (i % 6);
    const arrival = new Date(today);
    arrival.setUTCDate(today.getUTCDate() + arrivalOffset);
    const departure = new Date(arrival);
    departure.setUTCDate(arrival.getUTCDate() + stayLength);
    const room = (100 + ((i * 13) % 580)).toString();
    const emailLocal = `${first}.${last.replace(/\s+/g, '')}`
      .toLowerCase()
      .replace(/[^a-z0-9.]/g, '');
    guests.push({
      id: (i + 1).toString(),
      name: `${first} ${last}`,
      email: `${emailLocal}@example.com`,
      arrival: formatDate(arrival),
      departure: formatDate(departure),
      room,
      status,
      firstname: `${first}`,
      lastname: `${last}`,
    });
  }
  return guests;
}

export const GUESTS_SEED: readonly Guest[] = buildSeedGuests(50);
